import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { CalibartionCreateDilaogComponent } from 'app/dialogs/calibartion-create-dilaog/calibartion-create-dilaog.component';
import { CreateCertificateDialogComponent } from 'app/dialogs/create-certificate-dialog/create-certificate-dialog.component';
import { CreateDeliveryDeviceComponent } from 'app/dialogs/create-delivery-device/create-delivery-device.component';
import { CreateDeviceDialogComponent } from 'app/dialogs/create-device-dialog/create-device-dialog.component';
import { DeliveryDeviceUpdateDialogComponent } from 'app/dialogs/delivery-device-update-dialog/delivery-device-update-dialog.component';
import { DeliveryUpdateDialogComponent } from 'app/dialogs/delivery-update-dialog/delivery-update-dialog.component';
import { EncryptionUrlService } from 'app/services/common/encryption-url.service';
import { DeliveryDeviceService } from 'app/services/models/delivery-device.service';
import { DeliveryService } from 'app/services/models/delivery.service';
import { DeviceService } from 'app/services/models/device.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-delivery-update',
  templateUrl: './delivery-update.component.html',
  styleUrls: ['./delivery-update.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DeliveryUpdateComponent implements OnInit {
  public contentHeader: object;
  delivery: any = {};

  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any[] = [];
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption = 5;
  public searchValue = '';
  totalCount: number = 0;
  public ColumnMode = ColumnMode;
  devices: any = [];
  deviceList: any[] = [];
  constructor(
    private deliveryService: DeliveryService,
    private activatedRouter: ActivatedRoute,
    private deliveryDevice: DeliveryDeviceService,
    private modalService: NgbModal,
    private deviceService: DeviceService,
    private toastrService: ToastrService
  ) {
    this.contentHeader = {
      headerTitle: 'Teslim',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Teslim Listesi',
            isLink: true,
            link: '/admin/delivery'
          },
          {
            name: 'Teslim Detayı',
            isLink: false,
          },
        ]
      }
    }
  }

  async ngOnInit() {
    this.deliveryService.event$.subscribe(result => {
      this.activatedRouter.params.subscribe(async params => {
        await this.getByIdDelivery(params['id'])
      })
    })
    this.activatedRouter.params.subscribe(async params => {
      await this.getByIdDelivery(params['id'])
    })

    this.deliveryDevice.event$.subscribe(async params => {
      await this.getDeliveryByIdDevices(this.pageBasic - 1, this.selectedSize, this.delivery.id);
    })
  }

  async getAllDevice(search: string, companyId: number) {
    const data = await this.deviceService.getAllDevices(0, 1000, search, companyId, null, null, null);
    this.devices = data.devices;
  }

  async getByIdDelivery(id) {
    const data = await this.deliveryService.getByIdDelivery(id);
    this.delivery = data;
    console.log(this.delivery);
    await this.getDeliveryByIdDevices(this.pageBasic - 1, this.selectedSize, this.delivery.id);
    await this.getAllDevice('', this.delivery.companyId)
  }

  async getDeliveryByIdDevices(page, size, id) {
    const data = await this.deliveryDevice.getDeliveryByIdDevices(page, size, id);
    console.log(data);
    this.rows = data.deliveryDevices;
    this.totalCount = data.totalCount;
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption);
    await this.getDeliveryByIdDevices(this.pageBasic - 1, this.selectedSize, this.delivery.id);
  }

  async onPageChange() {
    await this.getDeliveryByIdDevices(this.pageBasic - 1, this.selectedSize, this.delivery.id);
  }

  deviceControl = new FormControl(null);

  onDeviceSelect(event) {
    console.log(event);
    this.showCreateDeliveryDevice(event?.id, `${event.brandName} ${event.modelName} - ${event.seriNo}`, event.companyPersonId, event.companyId);
    this.deviceControl.reset();
  }

  showCreateDeliveryDevice(deviceId, deviceName, companyPersonId, companyId) {
    const modal = this.modalService.open(CreateDeliveryDeviceComponent, {
      windowClass: 'modal modal-success',
      centered: true
    });
    modal.componentInstance.data = {
      id: null,
      deviceId: deviceId,
      deviceName: deviceName,
      companyPersonId: companyPersonId,
      companyId: companyId
    };
    modal.result.then(async (result) => {
      if (result) {
        console.log(result);
        const deliverydevice = this.rows.find(p => p.deviceId == result.deviceId);
        console.log(deliverydevice);
        if (deliverydevice) {
          this.toastrService.error("Bu cihaz zaten ekli");
        } else {
          const payload = {
            deviceId: result.deviceId,
            companyId: result.companyId,
            deliveryId: this.delivery.id,
            deliveryDate: null,
            deliveryMethodId: null,
            deviceAcceptanceStatesId: 1,
            deliveryPerson: null,
            personId: null,
            deliveryCompanyPersonId: null,
            isDeliveryStatus: false
          };

          const data = await this.deliveryDevice.createDeliveryDevice(payload);
          if (data.status) {
            this.toastrService.success(data.message);
            await this.getDeliveryByIdDevices(this.pageBasic - 1, this.selectedSize, this.delivery.id);
          }
          else {
            this.toastrService.error(data.message);
          }
        }
      }
    }, (reason) => {
      console.log('Modal kapatıldı:', reason);

    });
  }

  showCreateDeviceDialog() {
    const modal = this.modalService.open(CreateDeviceDialogComponent, {
      size: 'lg',
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      companyId: this.delivery.companyId
    }
  }

  showDeliveryUpdateDilaog(id) {
    const modal = this.modalService.open(
      DeliveryUpdateDialogComponent, {
      size: 'lg',
      windowClass: 'modal modal-warning'
    });
    modal.componentInstance.data = id;
  }

  showDeliveryDeviceUpdateDilaog(id) {
    const modal = this.modalService.open(DeliveryDeviceUpdateDialogComponent, {
      windowClass: 'modal modal-warning',
      centered: true,
      size: 'sm'
    }
    );
    modal.componentInstance.data = {
      id: id,
      companyId: this.delivery.companyId
    };
  }

  async deliveryCompanyId(row) {
    console.log(row);
    const modal = this.modalService.open(CreateDeliveryDeviceComponent, {
      windowClass: 'modal modal-success',
      centered: true
    });
    modal.componentInstance.data = {
      id: row.id,
      deviceId: row.deviceId,
      deviceName: row.deviceName,
      companyPersonId: row.companyPersonId,
      companyId: row.companyId
    };
  }

  async showCreateCalibrationDialog(id) {
    const modal = this.modalService.open(CalibartionCreateDilaogComponent, {
      size: 'xl',
      windowClass: 'modal modal-success'
    }
    );
    modal.componentInstance.data = {
      id: id,
      dialogTitle: "Kalibrasyon Yap"
    }
  }

  async showCreateCertificate(calibratioId) {
    const modal = this.modalService.open(CreateCertificateDialogComponent, {
      size: 'lg',
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      calibrationId: calibratioId,
    }
  }
}